module.exports = __webpack_public_path__ + "img/difficultyLevel_5.f11f5456.svg";